var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadphonesSuccess = function SvgHeadphonesSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.382 16.401h-3.5c-.481 0-.893-.172-1.236-.515a1.685 1.685 0 0 1-.514-1.236l.001-6.125c0-1.093.208-2.118.624-3.073a8.004 8.004 0 0 1 1.685-2.494 8.004 8.004 0 0 1 2.494-1.684A7.619 7.619 0 0 1 8.009.651c1.094 0 2.118.208 3.074.624a8.004 8.004 0 0 1 2.493 1.685 8.004 8.004 0 0 1 1.684 2.494c.416.955.623 1.98.623 3.073v6.125c0 .482-.172.894-.515 1.236a1.685 1.685 0 0 1-1.236.514h-3.5l.001-7h3.5v-.875c0-1.706-.594-3.154-1.782-4.342C11.163 2.996 9.715 2.402 8.009 2.4c-1.706 0-3.154.594-4.342 1.783-1.19 1.188-1.784 2.635-1.784 4.342V9.4h3.5v7Zm-1.75-5.25h-1.75v3.5h1.75v-3.5Zm8.75 0v3.5l1.75.001v-3.5h-1.75Z",
    fill: "#43A2AC"
  })));
};
export default SvgHeadphonesSuccess;